<template>
  <div class="nav-container">
    <div class="left">
      <el-menu router mode="horizontal" active-text-color="#D04247" :default-active="indexPath" @select="clickHeaderNav">
        <el-menu-item v-for="headerTabItem in headerTabMenu" :key="headerTabItem.id" :index="headerTabItem.path">{{
          headerTabItem.title }}
        </el-menu-item>
      </el-menu>
    </div>

    <div class="right">
      <div class="badgebox">
        <el-badge :value="massageNum">
          <div class="bellbox" @click="sendTips">
            <i class="el-icon-bell" style="font-size: 24px"></i>
          </div>
        </el-badge>
      </div>
      <!-- <div class="settingbox">
        <i class="el-icon-setting" style="font-size: 24px"></i>
      </div> -->
      <div class="userbox">
        <span class="usertext">{{ userInfo.nickname }}</span>
        <el-avatar shape="circle" :size="30" :src="circleUrl"></el-avatar>
        <!-- <el-avatar shape="circle" :size="30" :src="userInfo.thumb"></el-avatar> -->

        <el-dropdown>
          <span class="el-dropdown-link">
            <i class="el-icon-caret-bottom" style="color: #d8d8d8"></i>
          </span>
          <el-dropdown-menu slot="dropdown" class="dropdown">
            <el-dropdown-item disabled>管理首页</el-dropdown-item>
            <el-dropdown-item divided>律师首页</el-dropdown-item>
            <el-dropdown-item>财务首页</el-dropdown-item>
            <el-dropdown-item @click.native="qute">退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
export default {
  name: 'NavHeader',
  data() {
    return {
      indexPath:'/home',
      // 测试数据
      circleUrl: ''
    }
  },
  mounted() {
    if (this.userInfo.thumb) {
      this.circleUrl = `https://sxx.sxlawyer.net/${this.userInfo.thumb}`
    }
  },

  updated() {
    if (this.userInfo.thumb) {
      this.circleUrl = `https://sxx.sxlawyer.net/${this.userInfo.thumb}`
      this.indexPath = window.localStorage.getItem('fullPath')
    }
  },

  methods: {
    ...mapMutations('m_tabs', ['changeNavShow']),
    ...mapMutations('m_user', ['changeuserinfo']),
    sendTips() {
      this.changeNavShow()
    },
    async clickHeaderNav(index) {
      console.log(index);
      window.localStorage.setItem('fullPath',index)
      this.indexPath = index
      const result = this.headerTabMenu.find(item => item.path === index).id
      await this.$store.dispatch('m_tabs/asyncGetAsideTabMenuData', result)

    },
    qute() {
      this.changeuserinfo()
    }
  },
  computed: {
    ...mapState('m_tabs', ['headerTabMenu']),
    ...mapState('m_user', ['userInfo']),
    ...mapGetters('m_home', ['massageNum']),
    changeindexPath(){
        return 
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-container {
  display: flex;
  justify-content: space-around;
  align-items: center;
  position: relative;
  height: 100%;
  font-size: 14px;
  font-family: HarmonyOS Sans SC;

  .left {
    .el-menu {
      border-bottom: none;

      .el-menu-item {
        color: #606266;
      }
    }
  }

  .right {
    display: flex;
    justify-content: space-between;
    align-items: center;

    position: absolute;
    right: 0;
    margin-right: 30px;
    width: 210px;

    .userbox {
      display: flex;
      align-items: center;

      .usertext {
        margin-right: 5px;
        color: #c0c4cc;
      }
    }
  }

  /*去掉tabs底部的下划线*/
  .el-tabs__nav-wrap::after {
    position: static !important;
  }
}
</style>
